import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, FlexContainer } from '@rappi/rests-commons-front';
export const BottomBar = ({ backButton, nextButton }) => (_jsxs(FlexContainer, { justifyContent: "space-between", alignItems: "center", children: [_jsx(Button, Object.assign({}, backButton)), _jsx(Button, Object.assign({}, nextButton))] }));
